import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { TotalCropReportTable } from "../../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { Grid, Card, Container } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { annualLabourAttendanceMonitoringAverageReportSchema } from "../annualLabourAttendanceMonitoringAverageReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MaterialTable, { MTableBody } from "material-table";
import _, { flatMap } from 'lodash';
import $ from 'jquery';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

const screenCode = 'ANNUALLABOURATTENDANCEMONITORINGREPORT'
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});
export function AnnualLabourAttendanceMonitoringAverageReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [gang, setGang] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        gangID: "0",
        employeeTypeID: "0",
        year: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(annualLabourAttendanceMonitoringAverageReportSchema).options({ allowUnknown: true });
    const months = [
        { month: 1, monthName: "January" }, { month: 2, monthName: "February" },
        { month: 3, monthName: "March" }, { month: 4, monthName: "April" },
        { month: 5, monthName: "May" }, { month: 6, monthName: "June" },
        { month: 7, monthName: "July" }, { month: 8, monthName: "August" },
        { month: 9, monthName: "September" }, { month: 10, monthName: "October" },
        { month: 11, monthName: "November" }, { month: 12, monthName: "December" }
    ];
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [columeNames, setColumeNames] = useState([]);
    const [allTotal, setAllTotal] = useState([]);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [contentRowNames, setContentRowNames] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        collection: "",
        gang: "",
    });

    const [selectedDate, setSelectedDate] = useState(new Date());
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
    }, [searchData.operationEntityID])

    useEffect(() => {
        trackPromise(
            getGangByCollectionPointID()
        )
    }, [searchData.collectionPointID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWANNUALLABOURATTENDANCEMONITORINGREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    async function getGangByCollectionPointID() {
        const gang = await service.getGangByCollectionPointID(searchData.operationEntityID, searchData.collectionPointID);
        setGang(gang);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, annualLabourAttendanceMonitoringAverageReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }

    async function handleSearch(e) {

        const reportData = await service.GetReportDetails(searchData.operationEntityID, searchData.collectionPointID, searchData.gangID, searchData.employeeTypeID, selectedDate);
        setSelectedSearchData();
        let reportModel = reportData.dataModel
        let workModel = reportData.workModel

        reportModel.forEach(x => {
            let totalDays = 0;
            let total = 0;
            x.dataModel.forEach(y => {
                totalDays = totalDays + y.workCount;
                total = total + y.totalAmount;
            })
            x.totalDays = totalDays;
            x.total = total;
        });

        setReportData(reportModel);
        let newRes = _.cloneDeep(reportModel);
        var result = [];
        newRes.forEach(x => {
            x.dataModel.forEach(y => {
                var duplicateTotalRowData = result.find(z => z.month === y.month);
                if (duplicateTotalRowData) {
                    duplicateTotalRowData.month = y.month;
                    duplicateTotalRowData.total = duplicateTotalRowData.total == undefined ? 0 + y.totalAmount : duplicateTotalRowData.total + y.totalAmount;
                    duplicateTotalRowData.count = duplicateTotalRowData.count == undefined ? 0 + 1 : duplicateTotalRowData.count + 1;
                } else {
                    result.push({
                        month: y.month,
                        total: y.totalAmount,
                        count: 1
                    });
                }
            })
        });

        let newRes2 = _.cloneDeep(result);
        newRes2.forEach(x => {
            const resu = workModel.filter(y => y.month == x.month)
            x.actualDays = resu.length == 0 ? 0 : parseInt(resu[0].dataModel.length)
            x.pluckingAverage = ((x.total) / (x.actualDays * x.count))
        })
        setAllTotal(newRes2)
    }

    function checkUndifined(value) {
        if (value === undefined || value === NaN || value === "-") {
            return 0;
        } else {
            return value;
        }
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            division: collectionPoint[searchData.collectionPointID],
            employeeType: searchData.employeeTypeID,
            gag: gang[searchData.gangID]
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Annual Labour Attendance Monitoring & Average Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Division</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Division--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="gangID">Gang</InputLabel>
                                    <Select
                                        fullWidth
                                        id="gangID"
                                        name="gangID"
                                        value={searchData.gangID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Gang--</MenuItem>
                                        {generateDropDownMenu(gang)}
                                    </Select>
                                    {errors["gangID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["gangID"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-3 pb-1">
                                    <InputLabel shrink id="employeeTypeID">Pluking Type</InputLabel>
                                    <Select
                                        id="employeeTypeID"
                                        select
                                        fullWidth
                                        name="employeeTypeID"
                                        onChange={(e) => handleChange(e)}
                                        value={searchData.employeeTypeID}>
                                        <MenuItem value="0">--All Pluking Type--</MenuItem>
                                        <MenuItem value="GENERAL">General</MenuItem>
                                        <MenuItem value="RSM">RSM</MenuItem>
                                        <MenuItem value="CASH">Cash</MenuItem>
                                    </Select>
                                    {errors["employeeTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeTypeID"]}</FormHelperText>}
                                </div>
                                <div className="col-md-3 pb-1">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            fullWidth
                                            disableToolbar
                                            variant="inline"
                                            views={['year']}
                                            id="date-picker-inline"
                                            label="Year *"
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {reportData.length > 0 ?
                                <div className="form-group row">
                                    <div className="col-md-12 pb-1">
                                        <Container>
                                            <Card style={{ justifycontent: 'center' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer >
                                                        <Table aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow style={{ border: "2px solid black" }}>
                                                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Calendar Month</TableCell>
                                                                    {months.map((count, i) => (
                                                                        <TableCell key={i} align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>{count.monthName + ' ' + selectedDate.getFullYear()}</TableCell>
                                                                    ))}
                                                                    <TableCell align="center" colSpan={2} rowSpan={5} style={{ fontWeight: "bold", border: "2px solid black" }}>Total</TableCell>
                                                                </TableRow>
                                                                <TableRow style={{ border: "2px solid black" }}>
                                                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Actual Days Worked</TableCell>
                                                                    {months.map((count, i) => {
                                                                        const result = allTotal.find(x => x.month == count.month)
                                                                        return (
                                                                            <>
                                                                                <TableCell key={i} align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>{result == undefined ? '-' : parseInt(result.actualDays)}</TableCell>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </TableRow>
                                                                <TableRow style={{ border: "2px solid black" }}>
                                                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Total kgs</TableCell>
                                                                    {months.map((count, i) => {
                                                                        const result = allTotal.find(x => x.month == count.month)
                                                                        return (
                                                                            <>
                                                                                <TableCell key={i} align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>{result == undefined ? '-' : parseInt(result.total)}</TableCell>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </TableRow>
                                                                <TableRow style={{ border: "2px solid black" }}>
                                                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Total Gang Number</TableCell>
                                                                    {months.map((count, i) => {
                                                                        const result = allTotal.find(x => x.month == count.month)
                                                                        return (
                                                                            <>
                                                                                <TableCell key={i} align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>{result == undefined ? '-' : parseInt(result.count)}</TableCell>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </TableRow>
                                                                <TableRow style={{ border: "2px solid black" }}>
                                                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Daily Plucking Average (Kg)</TableCell>
                                                                    {months.map((count, i) => {
                                                                        const result = allTotal.find(x => x.month == count.month)
                                                                        return (
                                                                            <>
                                                                                <TableCell key={i} align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>{result == undefined ? '-' : parseInt(result.pluckingAverage)}</TableCell>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </TableRow>
                                                                <TableRow style={{ border: "2px solid black" }}>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Reg No</TableCell>
                                                                    <TableCell align="left" style={{ fontWeight: "bold", border: "2px solid black" }}>Employee Name</TableCell>
                                                                    {months.map((count) => {
                                                                        return (
                                                                            <>
                                                                                <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Work Count</TableCell>
                                                                                <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Daily Avg kg</TableCell>
                                                                            </>
                                                                        );
                                                                    })}
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Days</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Total (kg)</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {reportData.slice(page * limit, page * limit + limit).map((row, i) => (
                                                                    <TableRow style={{ border: "2px solid black" }} key={i}>
                                                                        <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}> {row.epfNo}</TableCell>
                                                                        <TableCell component="th" scope="row" align="left" style={{ fontWeight: "bold", border: "2px solid black" }}> {row.firstName}</TableCell>
                                                                        {months.map((count) => {
                                                                            const result = row.dataModel.find(x => x.month == count.month)
                                                                            const result2 = allTotal.find(x => x.month == count.month)
                                                                            return (
                                                                                <>
                                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}> {result == undefined ? '-' : result.workCount}</TableCell>
                                                                                    <TableCell
                                                                                        component="th"
                                                                                        scope="row"
                                                                                        style={{
                                                                                            fontWeight: "bold", border: "2px solid black",
                                                                                            backgroundColor: result == undefined ? null : (((result2 == undefined ? 0 : parseInt(result2.pluckingAverage)) == (result == undefined ? 0 : parseInt(result.totalAmount / result.workCount))) ? "#99ccff"
                                                                                                : ((result2 == undefined ? 0 : parseInt(result2.pluckingAverage)) < (result == undefined ? 0 : parseInt(result.totalAmount / result.workCount))) ? "#99ff99" : "#ff8566")
                                                                                        }}
                                                                                        align="center"
                                                                                    >
                                                                                        {result == undefined ? '-' : parseInt(result.totalAmount / result.workCount)}
                                                                                    </TableCell>
                                                                                </>
                                                                            );
                                                                        })}
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.totalDays}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.total}</TableCell>
                                                                    </TableRow>
                                                                )
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        component="div"
                                                        count={reportData.length}
                                                        onChangePage={handlePageChange}
                                                        onChangeRowsPerPage={handleLimitChange}
                                                        page={page}
                                                        rowsPerPage={limit}
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Container>
                                    </div>
                                </div> : null}
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Annual Labour Attendance Monitoring & Average Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} reportData={reportData} months={months}
                                            searchData={selectedSearchValues} allTotal={allTotal} selectedDate={selectedDate} />
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



